import { PortalTelemetryScreen } from '../../../app/telemetry/portalTelemetryScreens';
import { portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../app/telemetry/usePortalTelemetry';
import { useEffect } from "react";
import { ApiRequestStatus } from "../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { getCalendarEventInstancesAsync } from "../../../app/slices/calendarSlice";
import { useAppDispatch, useAppSelector } from "../../../app/store/configureStore";
import { MESSAGE_PROCESSING_DETAILS } from "../../../app/utils/constant";
import UpcomingEventsPage from "./UpcomingEventsPage";

export default function CalendarOfActivitiesForm() {

    const dispatch = useAppDispatch();
    const { calendarEventInstances, calendarEventInstancesStatus } = useAppSelector(state => state.calendar);

    useEffect(() => {
        dispatch(getCalendarEventInstancesAsync());
    }, [dispatch]);

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.CalendarOfActivitiesForm), undefined, !((calendarEventInstancesStatus === ApiRequestStatus.Pending)));

    if (calendarEventInstancesStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />;
    }

    return <UpcomingEventsPage events={calendarEventInstances ?? []} />;
}
